import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ReportFilterComponent} from './reportFilter.component';
import {DatePickerModule} from '@syncfusion/ej2-angular-calendars';
import {LoginCirclesModule} from '../loading-animation-2/loading-circles.module';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DatePickerModule,
        LoginCirclesModule
    ],
    declarations: [ReportFilterComponent],
    providers: [],
    exports: [ReportFilterComponent]
})

export class RegisterModule {

}
